import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { ButtonDropdown, DropdownMenuItem } from "components";
import { USERS_SET_LANGUAGE } from "utils";
import { useSelector } from "react-redux";
import { getConfig } from "store/features/materialSpecs/specs";

const buildLanguageDropdown = (languages: string[] | undefined) => {
    if (languages) {
        return languages.map((lang) => ({
            id: lang,
            label: lang,
        }));
    }
};

export const LanguageSelection: React.FC = () => {
    const { i18n } = useTranslation();
    const availableLanguages = useSelector(getConfig("languages"));
    const languages = buildLanguageDropdown(availableLanguages);
    const [selectedLanguage, setSelectedLanguage] = useState<DropdownMenuItem>();

    useEffect(() => {
        if (languages) {
            const selectedLanguage = localStorage.getItem(USERS_SET_LANGUAGE);
            if (selectedLanguage) {
                setSelectedLanguage(languages.find((lang) => lang.id === selectedLanguage) || languages[0]);
            }
        }

        // eslint-disable-next-line
    }, [availableLanguages]);

    const handleLanguageSelection = (language: DropdownMenuItem) => {
        i18n.changeLanguage(language.id);
        setSelectedLanguage(language);
        localStorage.setItem(USERS_SET_LANGUAGE, language.id);
    };

    return languages && selectedLanguage ? (
        <ButtonDropdown
            label={
                <Box display="flex" alignItems="center">
                    <Box pr={1}>{selectedLanguage.label}</Box>
                    <ExpandMoreIcon />
                </Box>
            }
            labelColor="black"
            items={languages}
            onSelect={handleLanguageSelection}
        />
    ) : null;
};
